"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllStencils = exports.getCustomizedStencilByName = exports.getStencilByName = exports.applyOverwrites = exports.getPropertyForStencil = void 0;
const ramda_1 = require("ramda");
const asset_creation_customization_1 = require("../customizations/asset-creation.customization");
const models_1 = require("../models");
const stencilsModule = __importStar(require("../stencils"));
const properties_util_1 = require("./properties.util");
const getPropertyForStencil = (stencil, propertyName, config) => {
    const defaultProperty = (0, properties_util_1.getPropertyByName)(propertyName);
    const stencilProperty = stencil.content[propertyName];
    const preferredFallbackProperty = stencilProperty ?? defaultProperty;
    if (!config || !stencil.overwrites?.length) {
        return preferredFallbackProperty;
    }
    const conditions = Object.keys(config);
    const relevantOverwrites = stencil.overwrites.filter((overwrite) => {
        if (!conditions.includes(overwrite.condition)) {
            return false;
        }
        return overwrite.argument === config[overwrite.condition];
    });
    const propertyOverride = (0, ramda_1.findLast)((overwrite) => {
        if (!overwrite.properties) {
            return false;
        }
        return Object.keys(overwrite.properties).includes(propertyName);
    }, relevantOverwrites);
    if (!propertyOverride?.properties) {
        return preferredFallbackProperty;
    }
    return propertyOverride?.properties?.[propertyName] ?? preferredFallbackProperty;
};
exports.getPropertyForStencil = getPropertyForStencil;
const applyContentAreasOverwrite = (stencil, overwrite) => {
    if (!overwrite.contentAreas?.length) {
        return stencil;
    }
    return {
        ...stencil,
        view: {
            ...stencil.view,
            contentAreas: overwrite.contentAreas,
        },
    };
};
const applyPreviewConfigurationOverwrite = (currentStencil, currentOverwrite) => {
    return {
        ...currentStencil,
        view: {
            ...currentStencil.view,
            previewConfiguration: {
                hasPagePreview: currentOverwrite?.previewConfiguration?.hasPagePreview ?? currentStencil.view.previewConfiguration?.hasPagePreview,
                hasFeatureCardPreview: currentOverwrite?.previewConfiguration?.hasFeatureCardPreview ?? currentStencil.view.previewConfiguration?.hasFeatureCardPreview,
            },
        },
    };
};
const applyOverwrites = (stencil, config) => {
    if (!stencil.overwrites?.length) {
        return stencil;
    }
    const conditions = Object.keys(config);
    const relevantOverwrites = stencil.overwrites.filter((overwrite) => {
        if (!conditions.includes(overwrite.condition)) {
            return false;
        }
        return overwrite.argument === config[overwrite.condition];
    });
    return relevantOverwrites.reduce((currentStencil, currentOverwrite) => {
        const stencilWithContentAreas = applyContentAreasOverwrite(currentStencil, currentOverwrite);
        return applyPreviewConfigurationOverwrite(stencilWithContentAreas, currentOverwrite);
    }, stencil);
};
exports.applyOverwrites = applyOverwrites;
const getStencilByName = (stencilName, config) => {
    const stencil = Object.values(stencilsModule).find((stencilEntry) => {
        return stencilEntry.name === stencilName;
    });
    if (!stencil) {
        throw new Error(`Stencil with name '${stencilName}' does not exist`);
    }
    if (config) {
        return (0, exports.applyOverwrites)(stencil, config);
    }
    return stencil;
};
exports.getStencilByName = getStencilByName;
const getCustomizedStencilByName = (stencilName, config) => {
    const stencil = (0, exports.getStencilByName)(stencilName, config);
    return {
        ...stencil,
        customization: { creatable: (0, asset_creation_customization_1.isStencilCreatable)(stencil, config) },
    };
};
exports.getCustomizedStencilByName = getCustomizedStencilByName;
const getAllStencils = () => {
    return Object.values(stencilsModule).filter(models_1.isStencil);
};
exports.getAllStencils = getAllStencils;
//# sourceMappingURL=data:application/json;base64,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